import { TagApi } from '@movilizame/networking';

export class PaymentsApi {

    constructor (net, list) {
        this.net = new TagApi(net, list);
    }
    /**
     * Listado de pagos
     * @param {object} data Filtros de notificaciones
     */
    index (data) {
        return this.net.get('/api/pagos/index', data);
    }

    /**
     * Obtiene la preparación para el metodo de pago
     */
    prepare (data) {
        return this.net.get('/api/pagos/preparar', data);
    }

    /**
     * Obtiene la preparación para el metodo de pago
     */
    information (data) {
        return this.net.get('/api/pagos/informacion', data);
    }

    /**
     * Guarda la configuración para un metodo de pago
     */
    create (data) {
        return this.net.post('/api/pagos/crear', data);
    }

    /**
     * Guarda la configuración para un metodo de pago
     */
    config (data) {
        return this.net.post('/api/pagos/configurar', data);
    }

    /**
     * Remueve un método de pago
     */
    remove (data) {
        return this.net.post('/api/pagos/remover', data);
    }

    /**
     * Remueve un método de pago
     */
    setAsDefault (data) {
        return this.net.post('/api/pagos/default', data);
    }
}



// WEBPACK FOOTER //
// ./src/services/api/Payments.js